<script>
  import Icon from '#lib/Icon.svelte';
  import t from '#lib/i18n.svelte.js';
  import { tweened } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';

  let {
    is_playing,
    timestamp = $bindable(),
    duration,
    title,
    toggle_play,
    class: css_class
  } = $props();

  /* ⛔️ IMPORTANT: if you change the radius, you need to update the stroke_dasharray variable */
  const stroke_dasharray = 116.239; // Circumference = 2 * Math.PI * 18.5 (radius)

  // Tweened store for smooth animation of playback progress (which updates only every second)
  let playback_progress = tweened(116.239, {
    duration: 500,
    easing: cubicOut
  });


  $effect(()=>{
    if (duration > 0 && timestamp >= 0) {
      playback_progress.set(stroke_dasharray - (stroke_dasharray * (timestamp / duration)));
    } else {
      playback_progress.set(stroke_dasharray); // Reset to full circle when out of bounds
    }
  });
</script>

<button
  class='play-pause-button {css_class}'
  aria-label={is_playing ? t('pause_video_for_title', {title}) : t('play_video_for_title', {title})}
  onclick={toggle_play}
>
  <Icon name={is_playing ? 'pause' : 'play'} style='--icon-color1: #FFF;' />
  <svg class='play-progress-circle' viewBox='0 0 42 42'> <!-- Size includes 2px padding for 4px stroke -->
    <!-- ⛔️ IMPORTANT: if you change the radius, you need to update the stroke_dasharray variable -->
    <circle class='progress-background' cx='21' cy='21' r='18.5'></circle> <!-- Radius = Total radius (18.5) - stroke width / 2 -->
    <circle class='progress-circle' cx='21' cy='21' r='18.5' style={`stroke-dasharray: ${stroke_dasharray}; stroke-dashoffset: ${$playback_progress};`}></circle>
  </svg>
</button>

<style lang='postcss'>
  .play-pause-button {
    min-width: var(--input-min-height);
    height: var(--input-min-height);
    display: flex;
    place-content: center;
    place-items: center;
    opacity: 0.8;
    transition: opacity 100ms ease;
    &:hover {
      opacity: 1;
      * {
        opacity: 1;
      }
    }
  }
  .play-progress-circle {
    margin: auto;
    position: absolute;
    width: var(--input-min-height);
    height: var(--input-min-height);
    fill: transparent;
    stroke: #FFF;
    transition: opacity 100ms ease;
    opacity: 0.4;
    stroke-width: 4px;
    stroke-linecap: round;
    pointer-events: none;
    transform: rotate(-90deg); /* Rotates the progress to start from the top */
  }
  .progress-background {
    stroke: oklch(0 0 0 / 0.3)
  }
</style>
